module.exports = __webpack_public_path__ + "media/customizations/samlarc/logo-d8598a7b3772b6a7e024370703ab40b7.png";